import { Component, OnInit } from '@angular/core';
import {DataService} from '../../shared/services/data.service';
import {ActivatedRoute, Router} from '@angular/router';
import {Title} from '@angular/platform-browser';

@Component({
  selector: 'app-cancel-order',
  templateUrl: './cancel-order.component.html',
  styleUrls: ['./cancel-order.component.scss']
})
export class CancelOrderComponent implements OnInit {

  constructor(
    private dataService: DataService,
    private route: ActivatedRoute,
    private router: Router,
    private pTitle: Title
  ) { }

  ngOnInit(): void {
    this.pTitle.setTitle(this.route.snapshot.data.title);
    this.dataService.hideHeaderFooter.next(true);
  }

  ngOnDestroy() {
    this.dataService.hideHeaderFooter.next(false);
  }
}
